import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking (Source company)',
    isStatic: false
  },
  borrowing_source_flag: {
    name: 'Borrowing source flag',
    isStatic: false
  },
  source_name: {
    name: 'Name of the largest source of borrowed cash or securities',
    isStatic: false
  },
  source_lei: {
    name: 'LEI code of the largest source of borrowed cash or securities',
    isStatic: false
  },
  source_bic: {
    name: 'BIC code of the largest source of borrowed cash or securities',
    isStatic: false
  },
  leverage_amount_received: {
    name: 'Received leverage amount',
    isStatic: false
  }
};

export function BorrowingSource({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { tables, columns, onChange } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.BORROWING_SOURCE,
    onChangeFund,
    schema: schema.BORROWING_SOURCE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.BORROWING_SOURCE?.field_names || [],
    columnLables,
    // @ts-ignore
    order: 296,
    isMultiFunds,
    funds,
    tableName: 'BORROWING_SOURCE'
  });

  return (
    <StyledTables id="reporttables-borrowing-source-group">
      {tables.map((rows, index: number) => (
        <Table
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
          key={index + 'BORROWING_SOURCE'}
          id={`reporttables-borrowing-source-table-${index + 1}`}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
        />
      ))}
    </StyledTables>
  );
}
